import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit, Output
} from '@angular/core';
import {bzIconCloseCircle, bzIconFilter} from '@bringoz/ui/icons';
import {SiteFiltersType} from "../../../types/site-filters.type";
import {FulfillmentSubTypeType} from "../../../../fulfillment/types/fulfillment-sub-type.type";
import * as angular from "angular";
import * as _ from "lodash";

require('./bringoz-filters-button.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-filters-button',
  templateUrl: './bringoz-filters-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozFiltersButtonComponent implements OnInit {

  readonly icons = {filter: bzIconFilter, reset: bzIconCloseCircle};

  @Input() includeFilters: SiteFiltersType[];
  @Input() optionIdsMap: any;
  @Input() excludeIdsMap: any;
  @Input() filters: any;
  @Input() selectedQuickFilterId?: string;
  @Input() pageName?: string;
  @Input() queryMap: {};
  @Input() hideDisplay?: boolean;
  @Input() isDisabled?: boolean;
  @Input() disabledText?: string;
  @Output() onChange = new EventEmitter<any>();

  public subFiltersTypes: SiteFiltersType[];
  public fulfillmentSubTypeType: typeof FulfillmentSubTypeType = FulfillmentSubTypeType;

  constructor(@Inject('commonsDialogService') private commonsDialogService, @Inject('viewFilterSettingsService') private viewFilterSettingsService) {
  }

  ngOnInit() {
    this.subFiltersTypes = [
      SiteFiltersType.noArea,
      SiteFiltersType.serviceAreaPickup,
      SiteFiltersType.serviceAreaDropoff,
      SiteFiltersType.serviceAreasServiceTypes,
      SiteFiltersType.noPickUpArea,
      SiteFiltersType.noDropOffArea,
      SiteFiltersType.groups
    ]
  }

  openDialog($event) {
    this.commonsDialogService.siteFilters($event, this.includeFilters, angular.copy(this.filters), this.selectedQuickFilterId, this.pageName, this.queryMap, this.excludeIdsMap, this.optionIdsMap)
      .then((res) => {
        this._setContextIds(res?.filters);
        this.onChange.emit({filters: res?.filters, selectedQuickFilter: res?.selectedQuickFilter})
      })
      .catch((error) => {
      })
  }

  hasFilters() {
    return !!this.includeFilters?.find((f) => {
      if (this.subFiltersTypes.includes(f)) {
        return false;
      }
      return _.isArray(this.filters[f]) ? !!this.filters[f]?.length : !_.isUndefined(this.filters[f]);
    });
  }

  onResetFilter(filterName) {
    if (filterName === 'groupIds') {
      this.excludeIdsMap.branchIds = [];
    }

    this.filters[filterName] = _.isArray(this.filters[filterName]) ? [] : undefined;

    if (filterName === 'serviceAreaIds' && !_.isUndefined(this.filters.noArea) && !_.isUndefined(this.filters.noPickUpArea) && !_.isUndefined(this.filters.noDropOffArea)) {
      this.filters.noArea = false;
      this.filters.noDropOffArea = false;
      this.filters.noPickUpArea = false;
    }

    this._setContextIds(this.filters);

    this.onChange.emit({filters: this.filters});
  }

  private _setContextIds(filters) {
    this.viewFilterSettingsService.setServiceAreaIds(filters?.serviceAreaIds || []);
    this.viewFilterSettingsService.setBranchIds(filters?.branchIds || []);
    this.viewFilterSettingsService.setAccountIds(filters?.accountIds || []);
    this.viewFilterSettingsService.setBillingAccountIds(filters?.billingAccountIds || []);
    this.viewFilterSettingsService.setBillingOrderStatus(filters?.billingOrderStatus || undefined);
    this.viewFilterSettingsService.setTags(filters?.tags || []);
    this.viewFilterSettingsService.setPackagesIds(filters?.packagesIds || []);
    this.viewFilterSettingsService.setBillingOrderInvoiceStatuses(filters?.billingOrderInvoiceStatuses || []);
    this.viewFilterSettingsService.setIsConsolidated(typeof filters?.isConsolidated === "boolean" ? filters?.isConsolidated : undefined);
    this.viewFilterSettingsService.setHasPrice(typeof filters?.hasPrice === "boolean" ? filters?.hasPrice : undefined);
    this.viewFilterSettingsService.setDateRangeTemplateType(filters.dateRangeTemplateType || undefined);
  }


}
